module.exports = __webpack_public_path__ + "img/measurement_info_left_waist_front.b790a8b8.jpg";